import update from './update'

const validators = {
  update
}

export default validators
